<app-dialog-container>
  <div fxLayout="column" fxLayoutGap="4">
    <!-- Cabeçalho e Botões -->
    <div fxLayout="row" fxLayoutAlign="space-between center">
      <div>
        <h1 mat-dialog-title>{{ title }}</h1>
      </div>
      <div>
        <button *ngIf="typeCes === typeCesEnum.EDIT" mat-icon-button (click)="changeType(typeCesEnum.SHOW)">
          <mat-icon class="btn-show">visibility</mat-icon>
        </button>
      </div>
    </div>
    
    <!-- Campos de Entrada com espaçamento reduzido -->
    <div fxLayout="row" fxLayoutGap="8px">
      <app-input [config]="getFieldConfig('soluctionName')" [typeCes]="typeCes" [group]="form"></app-input>
      <app-input [config]="getFieldConfig('partners')" [typeCes]="typeCes" [group]="form" (onSelect)="selectPartners($event)"></app-input>
    </div>

    <div fxLayout="row" fxLayoutGap="8px">
      <app-input [config]="getFieldConfig('type')" [typeCes]="typeCes" [group]="form" (onSelect)="changeTypeSystem($event)"></app-input>
      <app-input [config]="getFieldConfig('system')" [typeCes]="typeCes" [group]="form" ></app-input>
    </div>

    <div fxLayout="row" fxLayoutGap="8px">
      <app-input [config]="getFieldConfig('fileType')" [typeCes]="typeCes" [group]="form"></app-input>
      <app-input [config]="getFieldConfig('systemVersion')" [typeCes]="typeCes" [group]="form"></app-input>
      <app-input [config]="getFieldConfig('fileAttachment')" [typeCes]="typeCes" [group]="form"></app-input>
    </div>

    <div fxLayout="row" fxLayoutAlign="start center">
      <app-input [config]="getFieldConfig('fileDescription')" [typeCes]="typeCes" [group]="form"></app-input>
    </div>

    <!-- Botão de Salvar -->
    <div fxLayout="row" fxLayoutAlign="end center" fxFlex="10">
      <button mat-raised-button color="primary" [disabled]="!form.valid" (click)="onSubmit(form.value)">
        Salvar
      </button>
    </div>
  </div>
</app-dialog-container>
